import React, {useState, useEffect} from 'react';
import CustomTable from '../../components/customTable/CustomTable';
import {t, getLanguage} from 'react-switch-lang';
import './KeyRiskIndicators.scss';
import SelectList from '../../components/select/Select';
import {
  getAllProcesses,
  getAllSubProcesses,
  getAllDepartments,
  deleteKeyRisk,
  copyAllKeyIndicators,
  getCountAllDepartments,
} from '../../services/keyRiskIndicatorsService';
import {ReactComponent as OptionsImg} from './img/options.svg';
import {ReactComponent as PlusImg} from './img/plus.svg';
import {useHistory} from 'react-router-dom';
import {useUserContext} from '../../contexts/UserContext';
import Prompt from '../../components/prompt/prompt';
import Toast from '../../components/toast/Toast';
import OccurrenceModal from './viewKeyRiskIndicator/riskOccurrenceModal/OccurrenceModal';
import Swal from 'sweetalert2';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import Dropdown from '../../components/droppdown/dropdown';
import roles from '../../utils/roles';

const KeyRiskIndicators = () => {
  const [processes, setProcesses] = useState([]);
  const [subProcesses, setSubProcesses] = useState([]);
  const [departments, setDepartments] = useState([]);

  /*** SubProcesses select is disabled if process is not selected and resets on process change ***/
  const [disabledSubProcessSelect, setDisabledSubProcessSelect] = useState(
    true
  );
  const [resetSelect, setResetSelect] = useState();

  const userAuthorities = useUserContext().authorities;
  const userDepartments = useDepartmentContext();
  let userDepartmentsIds = [];

  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );
  const userResponsible = userAuthorities.some((r) =>
    r.includes(roles.role_responsible_user)
  );
  const userInCharge = userAuthorities.some((r) =>
    r.includes(roles.role_user_in_charge)
  );

  userDepartments.forEach((department) => {
    userDepartmentsIds.push(department.id);
  });

  const actionsRedirect = {
    editUrl: '/key-risk-indicators/edit',
    editTooltip: 'Pages.KeyRiskIndicators.editKeyRiskIndicator',
    damageTooltip: 'Pages.KeyRiskIndicators.damageKeyRiskIndicator',
    deleteTooltip: 'Pages.KeyRiskIndicators.deleteKeyRiskIndicator',
  };
  const actionsWidth = 100;

  /*** For constructing filters query ***/
  const query = new Map([]).set('activate.equals', true);
  const [complexQuery, setComplexQuery] = useState(
    userSuperAdmin || userRiskSector
      ? query
      : query.set('departmentId.in', userDepartmentsIds)
  );

  let history = useHistory();

  let lang = getLanguage();

  const fetchProcesses = async () => {
    try {
      const {data} = await getAllProcesses();
      setProcesses(data);
      return data;
    } catch (e) {}
  };

  // const fetchDepartments = async () => {
  //   try {
  //     const {data} = await getAllDepartments();
  //     setDepartments(data);
  //     return data;
  //   } catch (e) {}
  // };

  const fetchCountDepartments = async () => {
    try {
      const {data} = await getCountAllDepartments();
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    /*** Processes ***/
    fetchProcesses().then((r) => {
      let processesArray = [];
      r.forEach((item) => {
        processesArray.push({
          id: item.id,
          name: lang === 'eng' ? item.nameEn : item.name,
        });
      });
      setProcesses(processesArray);
    });

    fetchCountDepartments().then((r) => {
      const fetchDepartments = async () => {
        try {
          const {data} = await getAllDepartments(r);
          setDepartments(data);
          return data;
        } catch (e) {}
      };
      fetchDepartments().then((r) => {
        let departmentsArray = [];
         r.forEach((item) => {
          departmentsArray.push({
            id: item.id,
            name: lang === 'eng' ? item.nameEn : item.name,
          });
        });
        setDepartments(departmentsArray);
      });
    });

    /*** Departments ***/

    // fetchDepartments().then(r => {
    //   let departmentsArray = [];
    //   r.forEach(item => {
    //     departmentsArray.push({'id': item.id, 'name': (lang === 'eng' ? item.nameEn : item.name)});
    //   });
    //   setDepartments(departmentsArray);
    // });
  }, []);

  const columns = [
    {
      dataIndex: lang === 'eng' ? 'processNameEn' : 'processName',
      title: t('Pages.KeyRiskIndicators.process'),
      editable: true,
      placeholder: t(''),
    },
    {
      dataIndex: lang === 'eng' ? 'subprocessNameEn' : 'subprocessName',
      title: t('Pages.KeyRiskIndicators.subProcess'),
      editable: true,
      placeholder: t(''),
    },
    {
      dataIndex:
        lang === 'eng' ? 'subprocessDescriptionEn' : 'subprocessDescription',
      title: t('Pages.KeyRiskIndicators.subProcessDescription'),
      editable: true,
      placeholder: t(''),
      width: 170,
    },
    {
      dataIndex: lang === 'eng' ? 'indicatorNameEn' : 'indicatorName',
      title: t('Pages.KeyRiskIndicators.indicatorName'),
      editable: true,
      placeholder: t(''),
    },
    // {
    //   key: 'value',
    //   title: t('Pages.KeyRiskIndicators.escalationPoint'),
    //   editable: true,
    //   placeholder: t(''),
    //   render: (request) => {
    //     let label = '';
    //     for (let period of periods) {
    //       if (period.value === request.indicatorPeriod) {
    //         label = period.label;
    //       }
    //     }
    //     return `${request.minValue} ${label}`
    //   }
    // },
    {
      dataIndex: lang === 'eng' ? 'minValue' : 'minValue',
      title: t('Pages.KeyRiskIndicators.escalationPoint'),
      editable: true,
      placeholder: t(''),
    },
    {
      dataIndex: lang === 'eng' ? 'departmentNameEn' : 'departmentName',
      title: t('Pages.KeyRiskIndicators.department'),
      editable: true,
      placeholder: t(''),
      width: 150,
    },
    {
      dataIndex: lang === 'eng' ? 'riskDescriptionEn' : 'riskDescription',
      title: t('Pages.KeyRiskIndicators.risk'),
      editable: true,
      placeholder: t(''),
    },
    {
      dataIndex: lang === 'eng' ? 'measuresEn' : 'measures',
      title: t('Pages.KeyRiskIndicators.measures'),
      editable: true,
      placeholder: t(''),
    },
  ];

  /*** Process selected callback ***/
  const getSelectedProcess = (selected) => {
    setDisabledSubProcessSelect(true);
    setResetSelect(false);
    if (selected !== false) {
      const selectedId = processes.find((item) => item.name === selected).id;

      /*** Fetch SubProcesses depending on chosen process ***/
      const fetchSubProcesses = async () => {
        try {
          const {data} = await getAllSubProcesses(selectedId);
          setSubProcesses(data);
          return data;
        } catch (e) {}
      };

      fetchSubProcesses().then((r) => {
        let subProcessesArray = [];
        r.forEach((item) => {
          subProcessesArray.push({
            id: item.id,
            name: lang === 'eng' ? item.nameEn : item.name,
          });
        });
        setSubProcesses(subProcessesArray);
        setResetSelect(null);
        setDisabledSubProcessSelect(false);
      });

      const tempMap = new Map(complexQuery);
      tempMap.set('processId.equals', selectedId);
      tempMap.delete('subprocessId.equals');
      /*** On process change remove subProcess from filters query ***/
      setComplexQuery(tempMap);
    } else {
      deleteFromQueryMap(['processId.equals', 'subprocessId.equals']);
      setResetSelect(true);
      setDisabledSubProcessSelect(true);
    }
  };

  /*** SubProcess selected callback ***/
  const getSelectedSubProcess = (selected) => {
    if (selected !== false) {
      const selectedId = subProcesses.find((item) => item.name === selected).id;
      setComplexQuery(
        new Map(complexQuery).set('subprocessId.equals', selectedId)
      );
    } else {
      deleteFromQueryMap(['subprocessId.equals']);
    }
  };

  /*** Department selected callback ***/
  const getDepartment = (selected) => {
    let selectedDepartments = [];
    let selectedIds = [];
    if (selected !== '') {
      selectedDepartments = selected.split(',');
      departments.forEach((department) => {
        selectedDepartments.forEach((item) => {
          if (department.name === item) {
            selectedIds.push(department.id);
          }
        });
      });
      setComplexQuery(
        new Map(complexQuery).set('departmentId.in', selectedIds)
      );
    } else {
      deleteFromQueryMap(['departmentId.in']);
    }
  };

  const deleteFromQueryMap = (queryNames) => {
    let tempMap = new Map(complexQuery);
    queryNames.forEach((queryName) => {
      tempMap.delete(queryName);
    });
    setComplexQuery(tempMap);
  };

  const toAddKey = () => {
    history.push('/key-risk-indicators/add');
  };

  const toSingleKey = (id) => {
    history.push(`/key-risk-indicators/${id}`);
  };

  const toEditKeyRisk = (id) => {
    history.push({
      pathname: `/key-risk-indicators/${id}`,
      state: {isEditing: true},
    });
  };

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteKeyRisk'),
        text: t('question.delete', {
          entity: t('Pages.common.keyRiskIndicator2'),
        }),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteKeyRisk(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('Pages.messages.deleteSuccess', {
                  entity: t('Pages.common.keyRiskIndicator'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError', {
                entity:
                  lang === 'eng'
                    ? t('Pages.common.keyRiskIndicator2')
                    : t('Pages.common.keyRiskIndicator3'),
              }),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateTable, setUpdateTable] = useState(false);
  const [tableRowId, setTableRowId] = useState();

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openAddModal = (id) => {
    setIsModalOpen(true);
    setTableRowId(id);
  };

  const copy = async () => {
    try {
      const response = await copyAllKeyIndicators();
      if (response.status === 204) {
        Toast.fire({
          title: t('Pages.messages.copySuccess', {
            entity: t('Pages.common.keyRiskIndicators'),
          }),
          icon: 'success',
        });
      }
    } catch (err) {
      Swal.fire({
        text: t('Pages.messages.copyError', {
          entity: t('Pages.common.keyRiskIndicators2'),
        }),
        icon: 'error',
      });
    }
  };

  return (
    <div>
      {userSuperAdmin || userRiskSector ? (
        <div className="controls d-flex align-items-center justify-content-end">
          <div className="administration-template">
            <div className="container-fluid pr-0 pl-0 ">
              <div className="row ml-0 mr-0 justify-content-end">
                <div className="col-3 col-padding d-flex justify-content-end">
                  <button
                    type="button"
                    className="primary-btn mr-2"
                    onClick={toAddKey}
                  >
                    <PlusImg />
                    <div className="ml-2">
                      {t('Pages.KeyRiskIndicators.add')}
                    </div>
                  </button>
                </div>
                <div className="d-flex align-items-center">
                  <Dropdown
                    buttonClass="options-btn"
                    trigger={<OptionsImg />}
                    children={
                      <>
                        <li
                          onClick={() => {
                            copy();
                          }}
                        >
                          {t('common.copy')}
                        </li>
                      </>
                    }
                  ></Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="administration-template">
        <div className="container-fluid pr-0 pl-0 mb-4">
          <div className="row ml-0 mr-0">
            <div className="col-4 col-padding">
              <SelectList
                list={processes.map((item) => item.name)}
                placeholder={t('Pages.KeyRiskIndicators.process')}
                selectedItem={getSelectedProcess}
              />
            </div>
            <div className="col-4 col-padding">
              <SelectList
                list={subProcesses.map((item) => item.name)}
                placeholder={t('Pages.KeyRiskIndicators.subProcess')}
                selectedItem={getSelectedSubProcess}
                disabled={disabledSubProcessSelect}
                selectValue={resetSelect}
                key={resetSelect}
              />
            </div>
            <div className="col-4 col-padding">
              <SelectList
                list={
                  userSuperAdmin || userRiskSector
                    ? departments.map((item) => item.name)
                    : userDepartments.map((item) => item.name)
                }
                placeholder={t('Pages.KeyRiskIndicators.department')}
                selectedItem={getDepartment}
                multiple={true}
              />
            </div>
          </div>
          <OccurrenceModal
            key={isModalOpen}
            keyId={tableRowId}
            title={t('Pages.ViewKeyRiskIndicator.add')}
            isOpen={isModalOpen}
            isClosed={closeModal}
            updateTable={() => {
              setUpdateTable(true);
            }}
            escPressed={() => {
              closeModal();
            }}
          />
        </div>
        <CustomTable
          api={'/key-indicators'}
          query={complexQuery}
          columns={columns}
          methods={{onDelete}}
          sort={lang === 'eng' ? 'indicatorNameEn' : 'indicatorName'}
          actionsRedirect={actionsRedirect}
          actionsWidth={actionsWidth}
          onClickRow={toSingleKey}
          onColumnAdd={openAddModal}
          onColumnEdit={toEditKeyRisk}
          updateTable={updateTable}
          key={updateTable}
          className={'table-hover'}
          roles={{
            userSuperAdmin: userSuperAdmin,
            userRiskSector: userRiskSector,
            userInCharge: userInCharge,
            userResponsible: userResponsible,
            departments: userDepartmentsIds,
          }}
        />
      </div>
    </div>
  );
};

export default KeyRiskIndicators;
